
export const valuecardInfo = (state = null, action) => {
    switch (action.type) {
      case 'SET_VALUE_CARD_INFO':
        return action.data;
      default:
        return state;
    }
  };

export const selectedValueCardBenefits = (state = [], action) => {
  switch (action.type) {
    case "SET_SELECTED_VALUECARD_BENEFITS":
      return action.data;
    case "CLEAR_SELECTED_VALUECARD_BENEFITS":
      return state;
    case "CANCEL_SELECTION":
      return null;
    default:
      return state;
  }
};

export const valueCardBenefitsResponse = (state = null, action) => {
  switch (action.type) {
    case 'SET_VALUECARD_BENEFITS_RESPONSE':
      return action.data;
    default:
      return state;
  }
};

export const valuecardItem = (state = null, action) => {
  switch (action.type) {
    case 'SET_VALUECARD_ITEM':
      return action.data;
    default:
      return state;
  }
};
